import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SidebarComponent } from "src/app/components/sidebar/sidebar.component";

@Component({
  selector: 'app-master-panel',
  standalone: true,
  imports: [
    RouterOutlet,
    SidebarComponent
  ],
  templateUrl: './master-panel.component.html',
  styleUrl: './master-panel.component.scss'
})
export class MasterPanelComponent {
  menuItems = [
    {
      icon: 'home',
      title: 'SIDEBAR.HOME',
      name: 'home',
      route: '/panel-master/home'
    },
    {
      icon: 'supervisor_account',
      title: 'SIDEBAR.CLIENTS',
      name: 'clients',
      route: '/panel-master/clients'
    },
    {
      icon: 'badge',
      title: 'SIDEBAR.EMPLOYEES',
      name: 'employees',
      route: '/panel-master/employees'
    },
    {
      icon: 'manage_accounts',
      title: 'SIDEBAR.USERS.TITLE',
      name: 'users',
      route: '/panel-master/users/master',
      subItems: [
        {
          title: 'SIDEBAR.USERS.MASTER',
          name: 'users-master',
          route: '/panel-master/users/master'
        },
        {
          title: 'SIDEBAR.USERS.ADMIN',
          name: 'users-admin',
          route: '/panel-master/users/admin'
        }
      ]
    },
    {
      icon: 'logout',
      title: 'SIDEBAR.LOGOUT',
      name: 'logout',
      route: '/login'
    }
  ];
}
